import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLSPINNINGTOP', label: 'Spinning Top', lookback: 10 })
